export var REPORT_TYPE_E;
(function (REPORT_TYPE_E) {
  REPORT_TYPE_E["APPLICATIONS_SUMMARY"] = "applications-summary";
  REPORT_TYPE_E["FIRM_STATISTICS"] = "firm-statistics";
  REPORT_TYPE_E["RENEWAL_TRACKING"] = "renewal-tracking";
  REPORT_TYPE_E["LENDER_TRANSACTIONS"] = "lender-transactions";
  REPORT_TYPE_E["RISK_LEVEL"] = "risk-level";
  REPORT_TYPE_E["COMMISSIONS"] = "commissions";
})(REPORT_TYPE_E || (REPORT_TYPE_E = {}));
export var REPORT_LEVEL_E;
(function (REPORT_LEVEL_E) {
  REPORT_LEVEL_E["EMPTY"] = "";
  REPORT_LEVEL_E["AGENT"] = "agent";
  REPORT_LEVEL_E["BROKERAGE"] = "brokerage";
})(REPORT_LEVEL_E || (REPORT_LEVEL_E = {}));
export var REPORT_FORMAT_E;
(function (REPORT_FORMAT_E) {
  REPORT_FORMAT_E["PDF"] = "pdf";
  REPORT_FORMAT_E["CSV"] = "csv";
})(REPORT_FORMAT_E || (REPORT_FORMAT_E = {}));
export var REPORT_APPLICATION_STATUS_E;
(function (REPORT_APPLICATION_STATUS_E) {
  REPORT_APPLICATION_STATUS_E["EMPTY"] = "";
  REPORT_APPLICATION_STATUS_E["ALL"] = "all";
  REPORT_APPLICATION_STATUS_E["SUBMITTED"] = "submitted";
  REPORT_APPLICATION_STATUS_E["DECLINED"] = "declined";
  REPORT_APPLICATION_STATUS_E["PENDING"] = "pending";
  REPORT_APPLICATION_STATUS_E["APPROVED"] = "approved";
  REPORT_APPLICATION_STATUS_E["ACCEPTED"] = "accepted";
  REPORT_APPLICATION_STATUS_E["CLOSED"] = "closed";
  REPORT_APPLICATION_STATUS_E["PAID"] = "paid";
  REPORT_APPLICATION_STATUS_E["CANCELLED"] = "cancelled";
})(REPORT_APPLICATION_STATUS_E || (REPORT_APPLICATION_STATUS_E = {}));
export var REPORT_RISK_LEVEL_E;
(function (REPORT_RISK_LEVEL_E) {
  REPORT_RISK_LEVEL_E["EMPTY"] = "";
  REPORT_RISK_LEVEL_E["ALL"] = "all";
  REPORT_RISK_LEVEL_E["HIGH"] = "high";
  REPORT_RISK_LEVEL_E["MEDIUM"] = "medium";
})(REPORT_RISK_LEVEL_E || (REPORT_RISK_LEVEL_E = {}));
export var REPORT_DATE_TYPE_E;
(function (REPORT_DATE_TYPE_E) {
  REPORT_DATE_TYPE_E["EMPTY"] = "";
  REPORT_DATE_TYPE_E["CLOSING_DATE"] = "closing-date";
  REPORT_DATE_TYPE_E["DATE_CREATED"] = "date-created";
  REPORT_DATE_TYPE_E["ACCEPTED_DATE"] = "accepted-date";
  REPORT_DATE_TYPE_E["MATURITY_DATE"] = "maturity-date";
  REPORT_DATE_TYPE_E["SUBMISSION_DATE"] = "submission-date";
  REPORT_DATE_TYPE_E["APPROVAL_DATE"] = "approval-date";
  REPORT_DATE_TYPE_E["FEE_RECEIVED"] = "fee-received";
})(REPORT_DATE_TYPE_E || (REPORT_DATE_TYPE_E = {}));
export var REPORT_GROUP_BY_E;
(function (REPORT_GROUP_BY_E) {
  REPORT_GROUP_BY_E["EMPTY"] = "";
  REPORT_GROUP_BY_E["APPLICATION_STATUS"] = "application-status";
  REPORT_GROUP_BY_E["LENDER"] = "lender";
  REPORT_GROUP_BY_E["MORTGAGE_TYPE"] = "mortgage-type";
  REPORT_GROUP_BY_E["APPLICATION_TYPE"] = "application-type";
  REPORT_GROUP_BY_E["AGENT"] = "agent";
  REPORT_GROUP_BY_E["SUBMISSION_STATUS"] = "submission-status";
})(REPORT_GROUP_BY_E || (REPORT_GROUP_BY_E = {}));
export var REPORT_SORT_BY_E;
(function (REPORT_SORT_BY_E) {
  REPORT_SORT_BY_E["EMPTY"] = "";
  REPORT_SORT_BY_E["LENDER"] = "lender";
  REPORT_SORT_BY_E["MORTGAGE_TYPE"] = "mortgage-type";
  REPORT_SORT_BY_E["APPLICATION_TYPE"] = "application-type";
  REPORT_SORT_BY_E["APPLICANT_SURNAME"] = "applicant-surname";
  REPORT_SORT_BY_E["APPLICATION_ID"] = "application-id";
  REPORT_SORT_BY_E["CLOSING_DATE"] = "closing-date";
  REPORT_SORT_BY_E["MATURITY_DATE"] = "maturity-date";
  REPORT_SORT_BY_E["AGENT"] = "agent";
  REPORT_SORT_BY_E["DEAL_STATUS"] = "deal-status";
  REPORT_SORT_BY_E["SUBMISSION_STATUS"] = "submission-status";
  REPORT_SORT_BY_E["APPROVAL_DATE"] = "approval-date";
  REPORT_SORT_BY_E["BROKERAGE"] = "brokerage";
  REPORT_SORT_BY_E["APR"] = "apr";
})(REPORT_SORT_BY_E || (REPORT_SORT_BY_E = {}));
export var REPORT_APPLICATION_TYPE_E;
(function (REPORT_APPLICATION_TYPE_E) {
  REPORT_APPLICATION_TYPE_E["EMPTY"] = "";
  REPORT_APPLICATION_TYPE_E["ALL"] = "all";
  REPORT_APPLICATION_TYPE_E["APPROVAL"] = "approval";
  REPORT_APPLICATION_TYPE_E["PRE_APPROVAL"] = "pre-approval";
})(REPORT_APPLICATION_TYPE_E || (REPORT_APPLICATION_TYPE_E = {}));
export var REPORT_FEE_TYPE_E;
(function (REPORT_FEE_TYPE_E) {
  REPORT_FEE_TYPE_E["MORTGAGE_INSURANCE"] = "mortgage-insurance";
  REPORT_FEE_TYPE_E["CLOSING_SERVICES"] = "closing-services";
  REPORT_FEE_TYPE_E["RETROACTIVE_FEE"] = "retroactive-fee";
  REPORT_FEE_TYPE_E["ADJUSTMENTS"] = "adjustments";
  REPORT_FEE_TYPE_E["REVERSE_FINDER_FEE"] = "reverse-finders-fee";
  REPORT_FEE_TYPE_E["REFERRAL_FEE"] = "referral-fee";
  REPORT_FEE_TYPE_E["BONUS"] = "bonus";
  REPORT_FEE_TYPE_E["OTHER"] = "other";
})(REPORT_FEE_TYPE_E || (REPORT_FEE_TYPE_E = {}));
export var REPORT_CASHFLOW_E;
(function (REPORT_CASHFLOW_E) {
  REPORT_CASHFLOW_E["PAID"] = "paid";
  REPORT_CASHFLOW_E["RECEIVABLE"] = "receivable";
})(REPORT_CASHFLOW_E || (REPORT_CASHFLOW_E = {}));